export default () => {
  return {
    type: "custom",
    templateName: "Contact us standard solution",
    diagnosticResponses: [],
    fields: [
      {
        name: "phone",
        content: "03456 100 381",
      },
      {
        name: "chat",
        content: "TechnicalSupport",
      },
      {
        name: "content",
        content: `
          <section>
            <h2>Product manuals may have advice on how to handle common problems</h2>
            <p>Check your product manual for help on set up and use or tips on how to deal with any issues.</p>
          </section>
          <section>
            <h2>We've created troubleshooting guides for large electrical appliances</h2>
            <p><a href='https://www.johnlewis.com/customer-services/troubleshooting-guides'>Our troubleshooting guides</a> have useful advice for typical problems with washing machines, tumble dryers, dishwashers, refrigerated appliances and TVs.</p>
            </section>
          <section>
            <h2>You can track the progress of a repair</h2>
            <p>If you've booked a repair for a small electrical item, use our tracking tool to see its progress. You'll just need your repair reference number.</p>
            <a href='/customer-services/repairs'>Track your repair</a>
          </section>`,
      },
    ],
    id: "brandOther",
  };
};
